module.exports = __webpack_public_path__ + "static/media/check.aad38cf8.svg";